import React from "react";
import PropTypes from "prop-types";

import {
    ListItemContainer,
    Left,
    Right,
    Center,
    Details,
    Content,
} from "./style";

const ListItem = (props) => (
    <ListItemContainer {...props} className={props.onClick ? "linked" : ""}>
        {props.icon ? <Left>{props.icon}</Left> : null}
        <Center>
            <Content>{props.children}</Content>
            {props.details ? <Details>{props.details}</Details> : null}
        </Center>
        {props.right ? <Right>{props.right}</Right> : null}
    </ListItemContainer>
);

ListItem.propTypes = {
    icon: PropTypes.any,
    children: PropTypes.any,
    details: PropTypes.any,
    right: PropTypes.any,
    onClick: PropTypes.func,
};

export default ListItem;
